import { IInvoicingService, emptyInvoicingService } from "./invoicing-service";
import { IDire, emptyDire } from "./dire";

/**
 * Base Interface representing the search result
 */
export interface IClientAdhesion {
  id: number,
  invoicingService: IInvoicingService;
  dire: IDire,
  invoicingServiceIdentifier: string,
  direCode: string,
  status: string;
  createdAt: string;
  selected: boolean;
}

export let emptyClientAdhesion: IClientAdhesion = {
  id: -1,
  invoicingService: emptyInvoicingService,
  dire: emptyDire,
  invoicingServiceIdentifier: '',
  direCode: '',
  status: '',
  createdAt: '',
  selected: false
};




// WEBPACK FOOTER //
// ./src/app/model/client-adhesion.ts